Pixlee.module('CoverflowApp.Show', function(Show, App, _Backbone, _Marionette, $) {
    Show.Layout = App.Views.Layout.extend({
        getTemplate: function() {
            if (App.isMobile) {
                return require('./templates/mobile_layout.jst.ejs');
            }
            return require('./templates/layout.jst.ejs');
        },
        regions: {
            widget_header_region: '#widget_header_region',
            interactive_region: '#interactive_region',
            frame: '.coverflow_frame'
        }
    });
    Show.Layout.include(['LayoutHelpers', 'AccessibilityHelpers']);

    Show.PhotoView = App.Views.ItemView.extend({
        template: require('../common/templates/v2/_photo_item.jst.ejs'),
        getTemplate: function() {
            var desktopPhotoQuality = App.isDesktop ? (gon.display_options && gon.display_options.photoQuality || 'default') : undefined;
            if (desktopPhotoQuality === 'xl' || desktopPhotoQuality === 'original') {
                return require('../common/templates/v2/_xl_photo_item.jst.ejs');
            } else {
                return require('../common/templates/v2/_photo_item.jst.ejs');
            }
        },
        className: 'photo_block',
        tagName: 'li',
        behaviors: {
            Reviews: {},
            Share: {},
            Vote: {},
            Lightbox: {},
            UpdateThumbnailCss: {}
        },
        initialize: function() {
            if (this.model.get('is_starred')) {
                this.$el.addClass('starred');
            }
        },
        templateHelpers: {
            decodeUtf8: function(string) {
                return App.request('decode:utf8', string);
            }
        }
    });
    Show.PhotoView.include(['PhotoViewHelpers', 'ReviewHelpers']);

    // Photowall View
    Show.CoverflowCollection = App.Views.CollectionView.extend({
        childView: Show.PhotoView,
        className: 'clearfix',
        tagName: 'ul',
        behaviors: function() {
            var behaviorHash = {
                CollectionVote: {},
                RefreshOnCssGenerated: {}
            };

            // for backwards compatibility with widgets that are already out in the wild
            if (_.isTruthy(this.options.displayOptions.headerOptions)) {
                behaviorHash.AppendUploaderTiles = {};
            }
            // if there's no upload tiles or if hideIfLessThanIsSet is set, then we need to have the ability to hide empty albums
            var noUploadButton = _.isFalsy(this.options.displayOptions.headerOptions.end_tile_upload_button_background_showHide);
            var setHideIfLessThan = !_.isFalsy(App.displayOptions.get('hideIfLessThan')) || !_.isFalsy(gon.current_account.extra_fields.hideIfLessThan);
            if (noUploadButton || setHideIfLessThan) {
                behaviorHash.HideEmptyAlbumWidget = {};
            }

            return behaviorHash;
        },
        /**
         * @param {{
         *      collection: 'Entity.Photo'[],
         *      displayOptions
         * }} options
         */
        initialize: function(_options) {
            this.collection.reviewSelectionOptions = {
                currentModelIndex: 0
            };
        },
        onShow: function() {
            $('#widget').attr('alt', App.altText);
            if (App.isDesktop) {
                this.setNextPageListener();
            }
        },
        fetchNextPage: function(extraFnc) {
            var _this = this;
            this.isFetching = true;
            this.collection.nextPage({
                success: function() {
                    _this.isFetching = false;
                    _this.sly.reload({
                        silentScroll: true
                    });
                    if (extraFnc) {
                        extraFnc.call(_this, _this.sly.items[1].center, true);
                    }
                }
            });
        },
        setNextPageListener: function() {
            var _this = this;
            //only send events on clicks not auto resize
            $('.next, .prev').click(function() {
                _this.initialLoad = false;
                if (_this.collection.length === 1) {
                    _this.initialLoad = true;
                    _this.fetchNextPage(_this.sly.slideTo);
                }
            });
        },
        getSlyOptions: function() {
            var isSmart = App.isDesktop;
            var mouseDragging = !App.isDesktop;
            var startAt = App.isDesktop ? 0 : 3;
            return {
                horizontal: 1,
                itemNav: 'forceCentered',
                smart: isSmart,
                activateMiddle: 1,
                activateOn: 'click',
                mouseDragging: mouseDragging,
                touchDragging: 1,
                releaseSwing: 1,
                startAt: startAt,
                scrollBy: 0,
                speed: 300,
                elasticBounds: this.elasticBounds,
                easing: 'swing',
                prevPage: $('.prev'),
                nextPage: $('.next')
            };
        },
        /**
         * @param {{
         *      start: number,
         *      center: number,
         *      end: number,
         *      cur: number,
         *      dest: number,
         *      old
         * }} position
         */
        onChange: function(position) {
            var _this = this;
            var debouncedDragNav = _.debounce(function(position, e) {
                var ev = !_.isFalsy(e) ? e.type : 'badEvent'; //if no event info, assume it was an invalid interaction
                var userInteractions = ['touchstart', 'touchend', 'touchmove', 'click'];

                //200 is a magic number but it's about 2 photos in the general case. we don't really need to be
                //that accurate here, other than preventing a tiny jolt from firing it off
                if (Math.abs(position.cur - _this.oldPosition) < 200 || userInteractions.indexOf(ev) < 0) {
                    return;
                } else if (position.cur > _this.oldPosition) {
                    App.commands.execute('nav:right', _this.sly.rel, _this.collection);
                } else {
                    App.commands.execute('nav:left', _this.sly.rel, _this.collection);
                }
                _this.oldPosition = position.cur;
            }, 250);

            if (!App.isDesktop) {
                if (position.cur !== 0) {
                    //some dumb things don't know what event is, so make sure it's defined
                    var eventObj = !_.isFalsy(typeof event) ? event : null;
                    debouncedDragNav(position, eventObj);
                }

                if (position.cur !== 0 && position.dest / position.end > 0.6 && !this.isFetching) {
                    this.isFetching = true;
                    this.collection.nextPage({
                        success: function() {
                            this.isFetching = false;
                            this.sly.reload({
                                silentScroll: true
                            });
                        }.bind(this)
                    });
                }
            } else {
                if (!this.initialLoad) {
                    if (position.dest > position.cur) {
                        App.commands.execute('nav:right', this.sly.rel, this.collection);
                    } else {
                        App.commands.execute('nav:left', this.sly.rel, this.collection);
                    }
                }

                if (!this.initialLoad && position.dest / position.end > 0.6 && !this.isFetching) {
                    this.fetchNextPage();
                    this.initialLoad = true;
                }
            }
        },
        /**
         *
         * @param {Error} e
         * @param {{
         *      middleItemIndex: number,
         *      photoQuality: string,
         *      photosInFrame: number,
         *      photoSize: number
         * }} options
         */
        onSlyError: function(e, options) {
            if (typeof window.pixSentry !== 'undefined') {
                var msg = 'Caught ' + e.name + ' when attempting to sly.slideTo() element ' + options.middleItemIndex + ': ';
                if (typeof photoSize !== 'undefined') {
                    msg += 'photoSize was \'' + options.photoSize + '; ';
                }
                if (typeof frameSize !== 'undefined') {
                    msg += 'frameSize was \'' + options.frameSize + '; ';
                }
                if (typeof photosInFrame !== 'undefined') {
                    msg += 'photosInFrame was \'' + options.photosInFrame + '; ';
                }
                window.pixSentry.captureMessage(msg);
            }
            throw e;
        },
        initSly: function() {
            var _this = this;
            if (!this.sly) {
                var coverflow_frame = $('.coverflow_frame');
                // this.setAccessibleElements() is defined in the 'tabindexHelpers' concern
                // which is only added on desktop
                var setAccessibleElements = this.setAccessibleElements ? this.setAccessibleElements.bind(this) : null;

                this.elasticBounds = gon.is_interactive ? 0 : 1;
                this.sly = new Sly(coverflow_frame, this.getSlyOptions(), {
                    change: function() {
                        var position = $(this)[0].pos;
                        _this.onChange(position);
                    },
                    move: function() {
                        if (setAccessibleElements) {
                            setAccessibleElements();
                        }
                    }
                }).init();
                if (this.setAccessibleElements) {
                    this.setAccessibleElements();
                }
            }
            // Reset the active node to be re-centered with sly.slideTo()
            this.sly.activate(0, true);

            var middleItemIndex;
            // If there are not enough photos to fill the frame
            if (this.sly.items[this.sly.items.length - 1].end < 0) {
                middleItemIndex = Math.ceil(this.sly.items.length / 2) - 1;
            } else {
                var photoSize = this.sly.items[0].size;
                var frameSize = this.sly.rel.frameSize;
                var photosInFrame = Math.floor(frameSize / photoSize);
                // Using one item above middle because it looks
                // better w overflow in the beginning of the frame
                middleItemIndex = Math.ceil(photosInFrame / 2);
            }
            try {
                this.sly.slideTo(this.sly.items[middleItemIndex].center, true);
            } catch (e) {
                this.onSlyError(e, {
                    middleItemIndex: middleItemIndex,
                    photoSize: photoSize,
                    frame: frameSize,
                    photosInFrame: photosInFrame
                });
            }
            if (this.sly.items.length === 1) {
                // Add an active class to the one and only node
                $(this.sly.items[0].el).addClass('active');
            }
        },
        onRender: function() {
            this.isFetching = false;
            this.oldPosition = 0;
            this.initialLoad = true;

            if (this.sly) {
                this.sly.reload({
                    silentScroll: true
                });
            }

            if (this.collection.length) {
                this.initSly();
            }
        }
    });
    if (App.isDesktop) {
        Show.CoverflowCollection.include(['tabindexHelpers', 'designEditorCollectionHelpers', 'socialShareHelpers']);
    } else {
        Show.CoverflowCollection.include(['designEditorCollectionHelpers', 'socialShareHelpers']);
    }
    Show.HeaderView = App.Views.ItemView.extend({
        template: require('../common/templates/v2/_header.jst.ejs'),
        id: 'widget_header',
        behaviors: {
            Upload: {},
            ShowPdpCaption: {}
        }
    });

    Show.HeaderView.include(['StandaloneHeaderHelpers']);

});
